import type { IconName } from '@iconik-io/uad';

export const segmentColors = [
  { value: '#73853f', label: 'Green' },
  { value: '#cc2e3b', label: 'Red' },
  { value: '#ad8db0', label: 'Violet' },
  { value: '#e46e34', label: 'Orange' },
  { value: '#ce9f3d', label: 'Yellow' },
  { value: '#ffffff', label: 'White' },
  { value: '#4993f7', label: 'Blue' },
  { value: '#49f3d7', label: 'Teal' },
];

export const SHARE_USER_EMAIL_PLACEHOLDER = '_SHARE_LINK_';

// Hack that we have to process a few existing assets that were created during
// the PDF player beta period. Before that we had page ranges as 1000ms for 1st page,
// 2000ms for 2nd and so on. After that we have pages 0ms for 1st, 1ms for 2nd.
export const pdfSegmentRangeThresholdDate = new Date(
  '2025-09-05T00:00:00.000Z',
);

export const commentTypes: {
  value: 'public' | 'is_internal';
  label: string;
  helpMessage: string;
  icon: IconName;
}[] = [
  {
    value: 'public',
    label: 'Public',
    helpMessage: 'All users and guests can see',
    icon: 'globe',
  },
  {
    value: 'is_internal',
    label: 'Internal',
    helpMessage: 'Only collaborators with access can see',
    icon: 'user_group',
  },
];
